<template>
    <div class="news_detail">
        <header>
            <a class="header_logo pc_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <a class="header_logo sp_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/sp_logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/NewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn btn_color" to="/sLogin" v-on:click="logout">ログアウト</button>
            </div>
            <div class="burger-btn" @click="naviOpen" :class="{'is-active': active}">
                <span class="bars">
                    <span class="bar bar_top"></span>
                    <span class="bar bar_mid"></span>
                    <span class="bar bar_bottom"></span>
                </span>
            </div>
            <transition name="navi">
                <nav class="navi" v-show="navi">
                    <ul class="navi__wrap">
                        <li><router-link class="header_link header_link2" to="/NewsList">ニュース一覧</router-link></li>
                        <li>{{$store.state.userName}}</li>
                        <li><button class="logout_btn btn_color sp_logout_btn" to="/sLogin" v-on:click="logout">ログアウト</button></li>
                    </ul>
                </nav>
            </transition>
        </header>
        <div class="news_detail_wrap">
            <h1>{{news.title}}</h1>
            <p class="delivery_date">{{news.post_date | dateFormat}}</p>
            <div class="news_detail_box">
                <table width="100%" height="100%">
                    <tr>
                        <th></th>
                        <td class="sp_txt_size">{{ news.body }}</td>
                    </tr>
                    <tr>
                        <th></th>
                        <td v-if="news.attach_file_mp4 != ''">
                            <video controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="url_protcol+domain+news.attach_file_mp4"></video>
                        </td>
                        <td v-if="news.attach_file_pdf != ''">
                            <!-- <iframe width="100%" height="100%" controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="news.attach_file_pdf+'#toolbar=0&navpanes=0'"></iframe> -->
                            <a v-bind:href="url_protcol+domain+news.attach_file_pdf" target="_blank" class="pdf-btn">PDFを開く</a>
                        </td>
                    </tr>
                </table>            
            </div>
        <router-link class="back" to="/NewsList">戻る</router-link>
        </div>
    </div>

</template>

<script>
window.onpageshow = function(event) {
	if (event.persisted) {
		window.location.reload();
	}
};
import moment from 'moment'
export default {
    data () {
        return {
            news: [],
            err_catch: false,
            active: false,
            navi: false,
            url_protcol: 'https://',
            domain: 'staff.ubiquitous-p.com',
            url_path: '/rest/get_notice_detail/',
        }
    },
    mounted () {
        this.axios
        .post(this.url_protcol + this.domain + this.url_path + this.$route.query.id + '/',{},{
                headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
            })
        .then(response => (
            this.news = response.data
            ))
    },
    filters: {
        dateFormat: function (value) {
            if (value !== '') {
                return moment(value).format('YYYY/MM/DD HH:mm')
            }
        }
    },
    methods: {
        naviOpen: function () {
            this.active = !this.active
            this.navi = !this.navi
        },
        logout() {
            this.$store.commit('reset');
            this.$router.push({name:'sLogin'});
        }
    }
}
</script>

<style scoped>
.news_detail {
    position: relative;
}

td {
    white-space: pre-wrap;
    word-break: break-all;
}

.news_detali_img {
    width: 60%;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -1;
}

.news_detali_img img {
    width: 100%;
}

h1 {
    margin: 40px 20px 0;
    word-break: break-all;
}

p.delivery_date {
    margin: 10px 20px;
    font-size: .8em;
    color: #A6A6A6;
}

.news_detail_wrap {
    width: 90vw;
    margin: 0 auto;
}

.news_txts {
    padding: 0 30px;
    margin: 20px 0;
}

.news_detail_box {
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    border-radius: 8px;
    padding: 30px 80px;
    background-color: rgba(255, 255, 255, 0.6);
}

a.back {
    width: 150px;
    height: 50px;
    display: block;
    background-color: #EE9D0B;
    color: #fff;
    border-radius: 5px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    margin: 50px 0;
}

.pdf-btn{
    width: 150px;
    height: 50px;
    display: block;
    background-color: #00AEEF;
    color: #fff;
    border-radius: 5px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    margin: 50px 0;
}

video {
    width: 100%;
    height: 420px;
}

iframe {
    width:100%;
    height:80vh;
}

.sp_logo {
    display: none;
}

@media screen and (max-width: 767px) {
    header img {
        width: 100%;
    }

    a.header_logo {
        width: 85%;
    }

    header {
        justify-content: normal;
    }

        .burger-btn{
        display: block;
        width: 39px;
        height: 39px;
        position: relative;
        z-index: 3;
    /*   codepenの挙動のため */
        background-color:transparent;
        border:none;
        margin: auto;
    }
    .bar{
        width: 20px;
        height: 1px;
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-color: #272727;
    }
    .bar_top{
        top: 10px;
    }
    .bar_mid{
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .bar_bottom{
        bottom: 10px;
    }
    .burger-btn.is-active .bar_top{
        transform: translate(-50%,10px) rotate(45deg);
        transition: transform .3s;
    }
    .burger-btn.is-active .bar_mid{
        opacity: 0;
        transition: opacity .3s;
    }
    .burger-btn.is-active .bar_bottom{
        transform: translate(-50%,-8px) rotate(-45deg);
        transition: transform .3s;
    }

    .navi__wrap {
        width: 50vw;
        height: 100vh;
        background-color: #EE9D0B;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        position: fixed;
        top: 0;
        right: 0;
        z-index: 2;
    }

    .navi__wrap li {
        margin-bottom: 2em;
    }

    .navi__wrap li:nth-child(1) {
        margin-top: 2em;
    }

    .navi__wrap a {
        color: #505050;
    }

    button.sp_logout_btn {
        background: none;
        border: none;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: #fff;
        padding: 3vw;
        display: block;
        width: 60%;
        border-radius: 5vw;
        margin: auto;
        color: #505050;
    }

    .header_right {
        display: none;
    }

    .news_detail_box {
        padding: 50px 5vw;
    }

    .news_txts {
        padding: 0;
        font-size: 3.3vw;
    }

    a.back {
        margin: 5vw auto;
        font-size: 3.5vw;
    }

    .pdf-btn{
        margin: 5vw auto;
        font-size: 3.5vw;
    }

    h1 {
        margin: 5vw;
        font-size: 5vw;
    }

    .sp_logo {
        display: block;
    }
    .pc_logo {
        display: none;
    }
    .sp_txt_size {
        font-size: 4vw;
    }

    .header_link2 {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue